import { createServerFn } from "@tanstack/react-start";

// Returns the count of curated, active programs we match applications against.
// Curated = owner_user_id IS NULL (investor rows have an owner and are excluded).
export const getActiveProgramCount = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const { supabaseAdmin } = await import("@/integrations/supabase/admin.server");
    const { count, error } = await supabaseAdmin
      .from("programs")
      .select("id", { count: "exact", head: true })
      .eq("active", true)
      .is("owner_user_id", null);
    if (error) return { count: null as number | null };
    return { count: count ?? null };
  } catch {
    return { count: null as number | null };
  }
});
